import type { z } from 'zod';

/**
 * Same runtime behavior as `schema.catch(defaultValue)` (falls back to
 * `defaultValue` on a missing *or* invalid value), but reports the same
 * input-optional / output-required type shape as `z.default()` so
 * TanStack Router's `Link`/`navigate` search types stay optional.
 *
 * Needed because Zod v4's own `.catch()` dropped the optional input type
 * `.catch()` had in v3 (https://zod.dev/v4/changelog), even though it still
 * accepts a missing/undefined value at runtime — this restores the type
 * without touching parsing behavior.
 */
export function fallback<T extends z.ZodType>(
  schema: T,
  defaultValue: z.output<T>,
): z.ZodDefault<z.ZodType<z.output<T>, z.input<T>>> {
  return schema.catch(defaultValue) as unknown as z.ZodDefault<
    z.ZodType<z.output<T>, z.input<T>>
  >;
}
